export var organizers = [
	{
		name: "Prof. Dr. Gerhard P. Fettweis",
		affiliation: "TU&nbsp;Dresden /<br>Barkhausen Institut",
		portrait: "GerhardFettweis.jpg",
		role: "General<br>Co-Chair",
	},

	{
		name: "Prof. Dr. Frank Fitzek",
		affiliation: "TU&nbsp;Dresden",
		portrait: "FrankFitzek.jpg",
		role: "General<br>Co-Chair",
	},

	{
		name: "Dr. Ashutosh  Dutta",
		affiliation: "Johns Hopkins University Applied Physics Lab",
		portrait: "AshutoshDutta.jpg",
		role: "General<br>Co-Chair",
	},
	{
		name: "Dr. Rico Radeke",
		affiliation: "TU&nbsp;Dresden",
		portrait: "RicoRadeke.jpg",
		role: "Organizing<br>Chair",
	},
	{
		name: "Florian Gast",
		affiliation: "TU&nbsp;Dresden",
		portrait: "florian-gast.jpg",
		role: "Program<br>Chair",
	},
	{
		name: "Carolin Bauder",
		affiliation: "TU&nbsp;Dresden",
		portrait: "CarolinBauder.jpg",
		role: "Industry Relations<br>Chair",
	},
	{
		name: "Daniel Swist",
		affiliation: "TU&nbsp;Dresden",
		portrait: "DanielSwist.jpg",
		role: "Technical Arrangements<br>Chair",
	},
	//{
	//	name: "Sandy Kratochwil",
	//	affiliation: "TU&nbsp;Dresden",
	//	portrait: "sandy.jpg",
	//	role: "Local Arrangements<br>Chair",
	//},


	// {
	// 	name: "Francisco Arroyo",
	// 	affiliation: "5G Lab Germany",
	// 	portrait: "francisco_arroyo.jpg",

	// },

	{
		name: "Fabian Diehm",
		affiliation: "TU&nbsp;Dresden",
		portrait: "fabian_diehm.jpg",
		role: "Web<br>Chair",
	},

];
